<div class="tab-inner-content">
  <h2>Vat Reports</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <div class="vat-report-title">
    <p>
      Vat Payable
    </p>
  </div>
  <table>
    <thead>
      <tr>
        <th>Account Name</th>
        <th>Reference</th>
        <th>Date</th>
        <th>Total Debit (In AED)</th>
        <th>Total Credit (In AED)</th>
        <th>Net Amount (In AED)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let node of vatPayable">
        <td>{{ node.accountName }}</td>
        <td>{{ node.reference }}</td>
        <td>{{ node.date | date : "MM/d/YYYY" }}</td>
        <td>{{ node.totalDebit | number : "1.2-2" }}</td>
        <td>{{ node.totalCredit | number : "1.2-2" }}</td>
        <td>{{ node.netAmount | number : "1.2-2" }}</td>
      </tr>
      <tr  *ngIf="vatPayable?.length !== 0" class="title">
        <td>Total</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>AED {{ vatReportData?.totalVatPayable | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="vatPayable?.length === 0">
        <td colspan="6" class="no-data">
          No data available
        </td>
      </tr>
    </tbody>
  </table>
  <div style="padding: 12px 0px"></div>
  <div class="vat-report-title">
    <p>
      Vat Receivable 
    </p>
  </div>
  <table>
    <thead>
      <tr>
        <th>Account Name</th>
        <th>Reference</th>
        <th>Date</th>
        <th>Total Debit (In AED)</th>
        <th>Total Credit (In AED)</th>
        <th>Net Amount (In AED)</th>
      </tr>
     
    </thead>
    <tbody>
      <tr *ngFor="let node of vatReceivable">
        <td>{{ node.accountName }}</td>
        <td>{{ node.reference }}</td>
        <td>{{ node.date | date : "MM/d/YYYY" }}</td>
        <td>{{ node.totalDebit | number : "1.2-2" }}</td>
        <td>{{ node.totalCredit | number : "1.2-2" }}</td>
        <td>{{ node.netAmount | number : "1.2-2" }}</td>
      </tr>
      <tr  *ngIf="vatReceivable?.length !== 0" class="title">
        <td>Total</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>AED {{ vatReportData?.totalVatReceivable | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="vatReceivable?.length === 0">
        <td colspan="6" class="no-data">
          No data available
        </td>
      </tr>
    </tbody>
  </table>
</div>
